// extracted by mini-css-extract-plugin
module.exports = {"dotBase":"Dot_dotBase__1hNFT","dotLarge":"Dot_dotLarge__3-G__"};